/**
 * 印章管理 接口
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 印章列表
  sealList: {
    url: `${api}/rest/v1/seal/list`,
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/list`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      status: {
        $type: Number
      },
      page: {
        $type: Number,
        $default: 1
      },
      pageSize: {
        $type: Number,
        $default: 30
      }
    }
  },
  // 被授权的印章列表
  grantList: {
    url: `${api}/rest/v1/seal/grant/list`,
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/grant/list`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      page: {
        $type: Number,
        $default: 1
      },
      needCert: {
        $type: Boolean,
        $default: false
      },
      pageSize: {
        $type: Number,
        $default: 30
      }
    }
  },
  // 获取他人账户信息
  otherInfo: {
    url: `${api}/rest/v1/account/info/other`,
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/grant/list`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      account: {
        $type: String
      }
    }
  },
  // 添加 模板印章 法人印章
  personTempalte: {
    url: `${api}/rest/v1/seal/person/template/add`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      templateType: {
        $type: String
      },
      color: {
        $type: String
      },
      name: {
        $type: String
      },
      personName: {
        $type: String
      },
      isSave: {
        $type: Boolean
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      }
    }
  },
  // 添加企业模板印章
  organTemplate: {
    url: `${api}/rest/v1/seal/organ/template/add`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      templateType: {
        $type: String
      },
      central: {
        $type: String
      },
      color: {
        $type: String
      },
      name: {
        $type: String
      },
      organName: {
        $type: String
      },
      hText: {
        $type: String
      },
      qText: {
        $type: String
      },
      isSave: {
        $type: Boolean
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      }
    }
  },
  // 上传手绘数据 /rest/v1/seal/hand/add
  sealHand: {
    url: `${api}/rest/v1/seal/hand/add`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      // 印章名称
      name: {
        $type: String
      },
      // 印章base64
      base64Data: {
        $type: String
      },
      // 使用人
      uses: {
        $type: Array
      },
      // 审计人
      audits: {
        $type: Array
      }
    }
  },
  // 处理图片印章 印章还原度
  compressImage: {
    url: `${api}/rest/v1/seal/image/compress`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      sealBase64: {
        $type: String
      },
      color: {
        $type: String
      },
      cvalue: {
        $type: Number
      }
    }
  },
  // 添加图片印章
  addImgSeal: {
    url: `${api}/rest/v1/seal/image/add`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      needCompress: {
        $type: Boolean,
        $default: true
      },
      name: {
        $type: String
      },
      imageBase64: {
        $type: String
      },
      color: {
        $type: String
      },
      cvalue: {
        $type: Number
      },
      width: {
        $type: Number
      },
      height: {
        $type: Number
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      },
      accountUid: {
        $type: String
      },
      sealType: {
        $type: String
      }
    }
  },
  // 获取手绘授权 CODE
  sealCode: {
    url: `${api}/rest/v1/seal/hand/code`,
    // url: 'http://115.238.39.106:28085/service/rest/v1/seal/hand/code',
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 获取手绘数据
  handData: {
    url: `${api}/rest/v1/seal/hand/data`,
    // url: 'http://115.238.39.106:28085/service/rest/v1/seal/hand/data',
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      code: {
        $type: String
      }
    }
  },
  // 编辑印章 /rest/v1/seal/update
  sealUpdateApi: {
    url: `${api}/rest/v1/seal/update`,
    method: Method.PUT,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      name: {
        $type: String
      },
      sealId: {
        $type: String
      },
      base64Data: {
        $type: String
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      },
      delUses: {
        $type: Array
      },
      delAudits: {
        $type: Array
      }
    }
  },
  // 删除印章 /rest/v1/seal/delete
  delSeal: {
    url: `${api}/rest/v1/seal/delete`,
    method: Method.DELETE,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      sealId: {
        $type: String
      }
    }
  },
  // 设置默认印章
  defSeal: {
    url: `${api}/rest/v1/seal/default`,
    method: Method.PUT,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      sealId: {
        $type: String
      }
    }
  },
  // 印章详情 /rest/v1/seal/detail
  detailSwalApi: {
    url: `${api}/rest/v1/seal/detail`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      sealId: {
        $type: String
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/seal.js